import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const ResolvableMissionTypePage_OneResolvableMissionType_QueryDocument =
  graphql(`
    query ResolvableMissionTypePage_OneResolvableMissionType_Query($id: Id!) {
      findOneResolvableMissionType(id: $id) {
        code
        label
        ...ResolvableMissionTypePage_Tabs_ResolvableMissionType_Fragment

        ...MissionPage_ServiceUsages_ResolvableMissionType_Fragment
        ...MissionReportInfoStateForm_ResolvableMissionType_Fragment
        ...MissionQuotationInfoStateForm_ResolvableMissionType_Fragment
      }
    }
  `);

export type ResolvableMissionTypePage_OneResolvableMissionType = ResultOf<
  typeof ResolvableMissionTypePage_OneResolvableMissionType_QueryDocument
>['findOneResolvableMissionType'];

export const useFindOneResolvableMissionTypeQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    ResolvableMissionTypePage_OneResolvableMissionType_QueryDocument,
    { id },
    { enabled: !!id },
  );
